module.exports = __webpack_public_path__ + "img/ico_qrcode_svg.6f2b0042.svg";